import TablaConciliacion from "../../../TablaConciliacion";

function TablaPob() {
  return <TablaConciliacion nombreUseCase="POB" titulo="POB" />;
}

export default TablaPob;
